import { normalizeQuotaOverview } from '@/integration/quota-overview'
import { quotaView } from '@/ai/presentation/quota'
import { errorMessage } from '@/ai/services/api'

// 方法绑定到原页面实例；不持有独立状态、请求实例或生命周期。
export default {
  adoptQuotaSummary(value, fromQuota = false) {
    if (!value || !Number.isFinite(value.asOf)) return
    const previous = this.quotaSummary
    if (previous && value.asOf < previous.asOf) return
    this.quotaSummary = value
    // Timestamps order snapshots; only a balance change/released reservation needs a refresh.
    if (!fromQuota && previous && (
      value.remainingTokens !== previous.remainingTokens ||
      value.reservedTokens < previous.reservedTokens
    )) this.queueQuotaRefresh()
  },
  queueQuotaRefresh() {
    if (!this._alive || !this.quotaOpen) return
    if (this.quotaLoading) { this._quotaRefreshPending = true; return }
    clearTimeout(this._quotaRefreshTimer)
    this._quotaRefreshTimer = setTimeout(() => {
      if (this._alive && this.quotaOpen) this.loadQuota()
    }, 0)
  },
  openQuota() {
    this.settingsOpen = false
    this.quotaOpen = true
    this.showHistory = false
    if (this.quotaLoading) this._quotaRefreshPending = true
    else this.loadQuota()
  },
  async loadQuota() {
    if (this.quotaLoading) return
    clearTimeout(this._quotaRefreshTimer)
    this.quotaLoading = true
    this.quotaError = ''
    try {
      const result = this.quotaOverviewSupported
        ? await this._quotaApi.post('quota/get')
        : await this.call('quota/get')
      if (!this._alive) return
      if ((result.asOf || 0) >= (this._quotaStamp || 0)) {
        this.quotaOverview = this.quotaOverviewSupported ? normalizeQuotaOverview(result) : null
        this.quota = !this.quotaOverviewSupported && quotaView(result) ? result : null
        this._quotaStamp = result.asOf || 0
        if (this.quotaOverviewSupported || this.quota) this.adoptQuotaSummary(result.quotaSummary, true)
      }
      this._quotaReceivedAt = Date.now()
    } catch (error) {
      if (!this._alive) return
      this.quota = null
      this.quotaOverview = null
      this.quotaError = errorMessage(error, this.pageState.copy.quotaUnavailable || '额度暂不可用，请重试。')
      // 查询失败不保留旧余额，也不显示成0；额度问题不打断用户对话。
      if (error.message === 'TOKEN_ERROR' || error.message === 'ACCOUNT_CHANGED' || error.message === 'AI_DISABLED' || error.message === 'AI_ROLE_DISABLED') this.fail(error)
    } finally {
      this.quotaLoading = false
      if (this._quotaRefreshPending) {
        this._quotaRefreshPending = false
        this.queueQuotaRefresh()
      }
    }
  }
}
